import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {MxTimezoneService} from '../../../../../mx-core/src/lib/shared/services/mx-timezone.service';

const TIMEZONE_URL: string = '/rest/timezone';

@Injectable({
    providedIn: 'root'
})
export class PrlTimezoneService implements MxTimezoneService {
    timezone: string;
    offset: string;

    constructor(
        private httpClient: HttpClient) {
    }

    init(): Observable<void> {
        return this.get()
            .pipe(
                map((response) => {
                    this.timezone = response;
                    this.offset = moment.tz(response).format('z');
                    moment.tz.setDefault(this.timezone);
                })
            );
    }

    get(): Observable<string> {
        return this.httpClient.get(TIMEZONE_URL, {responseType: 'text'});
    }

    public getTimezone(): string {
        return this.timezone;
    }


    public getOffset(): string {
        return this.offset;
    }
}
